function cov_ao7jtbcgd() {
  var path = "/app/src/constants/env.ts";
  var hash = "e9752933a4130b502111f40c6497029657434fb4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/constants/env.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 19
        },
        end: {
          line: 2,
          column: 34
        }
      },
      "1": {
        start: {
          line: 3,
          column: 19
        },
        end: {
          line: 3,
          column: 34
        }
      },
      "2": {
        start: {
          line: 4,
          column: 29
        },
        end: {
          line: 4,
          column: 54
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e9752933a4130b502111f40c6497029657434fb4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ao7jtbcgd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ao7jtbcgd();
/* eslint prefer-destructuring: 0 */
export var ENV = (cov_ao7jtbcgd().s[0]++, process.env.ENV);
export var TAG = (cov_ao7jtbcgd().s[1]++, process.env.TAG);
export var DD_CLIENT_KEY = (cov_ao7jtbcgd().s[2]++, process.env.DD_CLIENT_KEY);